<aside [ngClass]="{'active':  leadService.leadsAssignUpdateModal.isModalOpen }" class="footer-sidepanel footer-sidepanel--customer-search">
    <div class="footer-sidepanel__header">
        <h5><i class="fa-light fa-pen-to-square"></i>Transfer Leads</h5>
        <a (click)="leadService.closeLeadsAssignUpdateModal()"><i class="fa-light fa-xmark"></i></a>
    </div>
    <div class="footer-sidepanel__content">
      <div class="  form-wrapper-compact">
        <div class="flex-row">
          <div class="flex-col-sm-12">
            <section class="section form-wrapper-compact">
              <div class="section__content">
                
                <div class=" mb-10">
                  <!-- <div class="form-info mb-10"> -->
                    <!-- <h5 class="form-info__title">Campaign Program</h5> -->
                    <!-- <p class="form-info__content">Update your campaign program and details here.</p> -->
                  <!-- </div> -->
                  <div class="address-form">
                    <form
                      [formGroup]="leadService.assignLeadForm"
                      class="form-fields  form-container "
                    >
                      <div class="flex-row flex-row--compact">
                        <div class="flex-col-sm-6">
                          <div class="single-input-field-wrapper">
                            <label for="fname" class="form-fields__label">From User</label>
                            <!-- Dropdown List -->
                            <div class="dropdown-list-wrapper">
                              <div class="dropdown-list">
                                <f-dropdown
                                [filter]="true"
                                placeholder="Select user"
                                [options]="leadService.listOfAgents"
                                formControlName="fromUser"
                                optionLabel="UserName"
                                optionValue="Id"
                                [ngStyle]="{ width: '100%' }"
                                [style]="{ width: '100%' }"
                                [leftIconClass]="'fa-light fa-file-chart-column'"
                                (onChange)="handleLeadsDropDownSelect($event, 'From')"
                              >
                              </f-dropdown>
                              </div>
                            </div>
                            @if (leadService.checkAssignLeadFormFieldValidation("fromUser")) {
                            <div class="validation validation--error">Please provide source user.</div>
                            }
                            @if (leadService.getAssignLeadsFormValue("fromUser")) {
                              <div class="validation clr-gray">{{selectedUsers.fromUserName}} has <strong>{{selectedUsers.fromUserLeadsCount}}</strong> leads</div>
                              }
                          </div>
                        </div>
                        <div class="flex-col-sm-6">
                            <div class="single-input-field-wrapper">
                              <label for="fname" class="form-fields__label">To User</label>
                              <!-- Dropdown List -->
                              <div class="dropdown-list-wrapper">
                                <div class="dropdown-list">
                                  <f-dropdown
                                  [filter]="true"
                                  placeholder="Select user"
                                  [options]="leadService.listOfAgents"
                                  formControlName="toUser"
                                  optionLabel="UserName"
                                  optionValue="Id"
                                  [ngStyle]="{ width: '100%' }"
                                  [style]="{ width: '100%' }"
                                  [leftIconClass]="'fa-light fa-file-chart-column'"
                                  (onChange)="handleLeadsDropDownSelect($event,'To')"
                                >
                                </f-dropdown>
                                </div>
                              </div>
                              @if (leadService.checkAssignLeadFormFieldValidation("toUser")) {
                              <div class="validation validation--error">Please provide to user.</div>
                              }
                              @if (leadService.getAssignLeadsFormValue("toUser")) {
                                <div class="validation clr-gray">{{selectedUsers.toUserName}} has <strong>{{selectedUsers.toUserLeadsCount}}</strong> leads</div>
                                }
                            </div>
                          </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </section>
            <section class="section">
              <div class="section__content">
                <div class="flex-row flex-row--no-pad">
                  <div class="flex-col-sm-12">
                    <div class="form-secondary-header">
                      <div class="form-actions" style="width: 50%;">
                        <!-- Single-Button -->
                        <a (click)="leadService.closeLeadsAssignUpdateModal()" class="single-button--without-bg" style="margin-right: 10px;">Cancel</a>
                        <a (click)="handleLeadAssignment('Transfer')" class="single-button--with-bg" style="margin-right: 10px;">Transfer<i class="fa-light fa-arrow-right " style="padding-left: 5px;"></i></a>
                        <a (click)="handleLeadAssignment('Swap')" class="single-button--with-bg">Swap<i class="fa-light fa-arrow-right-arrow-left" style="padding-left: 5px;"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      
    </div>
</aside>